import * as yup from "yup";

const addAndChangeSchemaProject = (translate: Function, isAdd: boolean, projectStartDate: Date, projectEndDate: Date, validateDate: boolean) => yup.object().shape({
	pra002Titulo: yup.string().required(translate("Título é requerido")).max(200, translate("Título deve conter no máximo 200 caracteres")),
	pra002Efa005Id: yup.string().required(translate("Responsável é requerido")),
	pra002Efa005Id2: yup.string().required(translate("Autoridade é requerido")),
	pra002Kba001Id: yup.string(),
	pra002Pra001Id: isAdd ? yup.string().nullable() : yup.string(),
	pra002Dtiniest: yup.date()
		.required(translate("Data inicio do período é requerida"))
		.typeError(translate("Data inicio com data inválida")),
	pra002Dtfimest: yup.date()
		.required(translate("Data fim do período é requerida"))
		.typeError(translate("Data fim com data inválida"))
		.when("pra002Dtiniest",(initialDate,schema) => initialDate && schema.min(initialDate,translate("Data final não pode ser menor que a inicial"))),
	prtba003: yup.array().of(yup.object().shape({
		pra003Titulo: yup.string().required(translate("Título é requerido")),
		pra003Dtiniest: yup.date().nullable()
			.required(translate("Data inicio é requerida"))
			.typeError(translate("Data inicio com data inválida"))
			.when("pra002Dtiniest",(pra002Dtiniest,schema) => {
				if(validateDate){
					const dateStart = new Date(projectStartDate);
					const startDate = new Date(dateStart.toDateString());
					startDate.setDate(startDate.getDate());
					return startDate && schema.min(startDate,translate("Data início da fase não pode ser menor que a data início do projeto"));
				}
				return schema.nullable();
			}),
		pra003Dtfimest: yup.date()
			.required(translate("Data fim é requerida"))
			.typeError(translate("Data fim com data inválida"))
			.when("pra003Dtiniest",(pra003initialDate,schema) => pra003initialDate  && schema.min(pra003initialDate,translate("Data final não pode ser menor que a inicial")))
			.when("pra002Dtfimest",(pra002Dtfimest,schema) => {
				if(validateDate){
					const dateEnd = new Date(projectEndDate);
					const endDate = new Date(dateEnd.toDateString());
					endDate.setDate(endDate.getDate() + 1);
					return endDate && schema.max(endDate,translate("Data fim da fase não pode ser maior que a data fim do projeto"));
				}
				return schema.nullable();		
			})
	})),
	prtba005: yup.array().of(yup.object().shape({
		pra005Mea003Id: yup.string().required(translate("Objetivo é requerido"))
	}))
		.unique(translate("Objetivos não podem ser repetidos"), (a: any) => a.pra005Mea003Id),
	prtba006: yup.array().of(yup.object().shape({
		pra006Mee001Id: yup.string().required(translate("Estratégia é requerida"))
	}))
		.unique(translate("Estratégias não podem ser repetidas"), (a: any) => a.pra006Mee001Id),	
	prtba007: yup.array().of(yup.object().shape({
		pra007Id: yup.string(),
		pra007Notificaparticipante: yup.string(),
		pra007Tipo: yup.string(),
		pra007Efa005Id: yup.string(),
		pra007Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.pra007Efa005Id, (a: any) => !a.pra007Efa004Id && a.pra007Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.pra007Efa005Id, (a: any) => !a.pra007Efa004Id && a.pra007Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.pra007Efa004Id, (a: any) => !a.pra007Efa005Id && a.pra007Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.pra007Efa004Id, (a: any) => !a.pra007Efa005Id && a.pra007Tipo === "I")
});

const deleteSchemaProject = (translate: Function) => yup.object().shape({
	pra002Titulo: yup.string().required(translate("Título do projeto não confere")).oneOf([yup.ref("pra002TituloConfirmation")], translate("Título do projeto não confere"))
});

export { addAndChangeSchemaProject, deleteSchemaProject };
